import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';

import LivePlayerOrchestrator from 'components/UI/Orchestrator/LivePlayerOrchestrator';

const LivePlayerOrchestratorStyled = withStyles(theme => ({

}))(LivePlayerOrchestrator)

class LivePlayerOrchestratorWrapper extends Component {

  componentDidMount() {
    /*
    const {eventId}=this.props;
    if(eventId=='c78a02c687821c10f89e9637c357e1c8')
      this.tracking();
    */
  }

  tracking(){
    console.log("tracking!");
    window._adftrack = Array.isArray(window._adftrack) ? window._adftrack : (window._adftrack ? [window._adftrack] : []);
    window._adftrack.push({
        HttpHost: 'track.adform.net',
        pm: 1644357,
        divider: encodeURIComponent('|'),
        pagename: encodeURIComponent('FR_BIOCODEX_UNIVERSITEDUMICROBIOTE')
    });
    (function () { var s = document.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://s2.adform.net/banners/scripts/st/trackpoint-async.js'; var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x); })();
  }

  
  render() {
    return (<LivePlayerOrchestratorStyled templateProps={{kind: 'fullWidth', maxWidth: 'auto'}} {...this.props}/>)
  }
}

export default LivePlayerOrchestratorWrapper;



// WEBPACK FOOTER //
// ./src/components/Lives/LivePlayerOrchestrator.jsx